import { Component, ComponentFactoryResolver, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { SingleStudentComponent } from '../../../management360/program-and-service/single-student/single-student.component';
import { AnnouncementComponent } from '../../../shared-modules/announcement/announcement.component';
import { LoginService } from '../../../shared-modules/login/login.service';
import { SendEmailComponent } from '../../../shared-modules/send-email/send-email.component';
import { FormsWithinDocumentsComponent } from '../../../sped360/forms-within-documents/forms-within-documents.component';
import { AcademicHistoryComponent } from '../../../student360/academic-history/academic-history.component';
import { AssessmentComponent } from '../../../student360/assessment/assessment.component';
import { AssignmentComponent } from '../../../student360/assignment/assignment.component';
import { AttendanceComponent } from '../../../student360/attendance/attendance.component';
import { AwardsComponent } from '../../../student360/awards/awards.component';
import { CalendarComponent } from '../../../student360/calendar/calendar.component';
import { DisciplineComponent } from '../../../student360/discipline/discipline.component';
import { EFormsComponent } from '../../../student360/e-forms/e-forms.component';
import { FeesAndBillingComponent } from '../../../student360/fees-and-billing/fees-and-billing.component';
import { FreeReducedMealAppSummaryComponent } from '../../../student360/free-reduced-meal-app-parent/free-reduced-meal-app-summary/free-reduced-meal-app-summary.component';
import { GradesComponent } from '../../../student360/grades/grades.component';
import { GraduationPlanComponent } from '../../../student360/graduation-plan/graduation-plan.component';
import { HealthComponent } from '../../../student360/health/health.component';
import { IepComponent } from '../../../student360/iep/iep.component';
import { MealServiceComponent } from '../../../student360/meal-service/meal-service.component';
import { PortfolioComponent } from '../../../student360/portfolio/portfolio.component';
import { ProgramsAndServicesComponent } from '../../../student360/programs-and-services/programs-and-services.component';
import { ScheduleHistoryComponent } from '../../../student360/schedule-history/schedule-history.component';
import { StudentCourseRequestComponent } from '../../../student360/student-course-request/student-course-request.component';
import { StudentDetailsComponent } from '../../../student360/student-details/student-details.component';
import { StudentDigitalContentComponent } from '../../../student360/student-digital-content/student-digital-content.component';
import { StudentDocumentsComponent } from '../../../student360/student-documents/student-documents.component';
import { StudentFieldsComponent } from '../../../student360/student-fields/student-fields.component';
import { StudentScheduleComponent } from '../../../student360/student-schedule/student-schedule.component';
import { StudentSummaryComponent } from '../../../student360/student-summary/student-summary.component';
import { TeamsComponent } from '../../../student360/teams/teams.component';
import { TransportationComponent } from '../../../student360/transportation/transportation.component';
import { RouteInfo } from '../../routeInfo';
import { SharedService } from '../../shared.service';
import { SpinnerService } from '../../spinner/spinner.service';
import { StudentNotesSharedComponent } from '../../student-notes-shared/student-notes-shared.component';
import { UserService } from '../../user/user.service';
import { StudentInformationDirective } from '../student-information.directive';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-student-info-portal',
    templateUrl: './student-info-portal.component.html',
})

export class StudentInfoPortalComponent implements OnDestroy {

    portalName = '';
    studentViewRouteSubscription: Subscription;
    @ViewChild(StudentInformationDirective, { static: true }) studentInformation: StudentInformationDirective;

    @ViewChild('StudentInfo', { read: ElementRef, static: true }) elementRef: ElementRef;

    private _hasProgramAndServicePermission: any;
    public get hasProgramAndServicePermission(): any {
        return this._hasProgramAndServicePermission;
    }
    public set hasProgramAndServicePermission(value: any) {
        this._hasProgramAndServicePermission = value;
    }

    constructor(
        private dialog: MatDialogRef<StudentInfoPortalComponent>,
        private componentFactoryResolver: ComponentFactoryResolver,
        private userService: UserService,
        private sharedService: SharedService,
        private spinnerService: SpinnerService,
        private router: Router,
        private loginService: LoginService,
        private dialogRef: MatDialog,
    ) {
        this.studentViewRouteSubscription = this.userService.observableStudentInfoRouteStream$.subscribe((route) => {
            this.dialog.close();
        });
    }

    ngOnDestroy() { }

    showPortal(portalName: string) {
        let componentFactory: any;
        switch (portalName) {
            case 'Academic History':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(AcademicHistoryComponent);
                break;
            case 'Activities and Teams':
            case 'Activities':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(TeamsComponent);
                break;
            case 'Announcements':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(AnnouncementComponent);
                break;
            case 'Assessments':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(AssessmentComponent);
                break;
            case 'Assignments':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(AssignmentComponent);
                break;
            case 'Attendance':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(AttendanceComponent);
                break;
            case 'Calendar':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(CalendarComponent);
                break;
            case 'Behavior':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(DisciplineComponent);
                break;
            case 'Documents':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentDocumentsComponent);
                break;
            case 'Fees & Billing':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(FeesAndBillingComponent);
                break;
            case 'Grades':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(GradesComponent);
                break;
            case 'Graduation Plan Progress':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(GraduationPlanComponent);
                break;
            case 'Health':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(HealthComponent);
                break;
            case 'Meal Service':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(MealServiceComponent);
                break;
            case 'Send Email':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(SendEmailComponent);
                break;
            case 'Student Details':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentDetailsComponent);
                break;
            case 'Student Digital Content':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentDigitalContentComponent);
                break;
            case 'Student Portfolio':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(PortfolioComponent);
                break;
            case 'Student Schedule':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentScheduleComponent);
                break;
            case 'Student Summary':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentSummaryComponent);
                break;
            case 'Transportation':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(TransportationComponent);
                break;
            case 'Awards':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(AwardsComponent);
                break;
            case 'Programs and Services':
                if (this.hasProgramAndServicePermission) {
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SingleStudentComponent);
                } else {
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ProgramsAndServicesComponent);
                }
                break;
            case 'Monthly Lunch Menu':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(MealServiceComponent);
                break;
            case 'Student Fields':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentFieldsComponent);
                break;
            case 'Individualized Education Program':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(IepComponent);
                break;
            case 'Special Services':
                if (this.userService.userType == 1 && (this.loginService.LoginSettings.UseSection504 == true || this.loginService.LoginSettings.EnableSped360 == true) && !this.loginService.LoginSettings.V10) {
                    this.router.navigateByUrl('/sped360/studentDocumentHome');
                    this.dialogRef.closeAll();
                } else {
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(IepComponent);
                }
                break;
            case 'Student Notes':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentNotesSharedComponent);
                break;
            case 'e-Forms':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(EFormsComponent);
                break;
            case 'Schedule History':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(ScheduleHistoryComponent);
                break;
            case 'Course Requests':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(StudentCourseRequestComponent);
                break;
            case 'Free/Reduced Meal Application':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(FreeReducedMealAppSummaryComponent);
                break;
            case 'Form Within Document':
                componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormsWithinDocumentsComponent);
                break;
        }

        const viewContainerRef = this.studentInformation.viewContainerRef;
        viewContainerRef.clear();
        viewContainerRef.createComponent(componentFactory);
        setTimeout(() => {
            this.elementRef.nativeElement.parentElement.firstChild.style.display = 'flex';
            this.elementRef.nativeElement.parentElement.firstChild.style.flexDirection = 'column';
            this.elementRef.nativeElement.parentElement.firstChild.style.flexGrow = '1';
        }, 0);
    }

    closeClick() {
        this.dialog.close();
    }
    printClick() {
        const pagePrintStyle: string = RouteInfo.getPagePrintStyle(this.router.url);
        const styleURLs: string[] = ['./assets/styles/print-styles.css'];

        if (pagePrintStyle) {
            styleURLs.push(pagePrintStyle);
        }

        this.spinnerService.showSpinner = true;
        const dialogRefId: string = this.elementRef.nativeElement.parentElement.parentElement.parentElement.id != undefined ? this.elementRef.nativeElement.parentElement.parentElement.parentElement.id.toString() : '';

        // Timeout is needed to allow the spinner to show before the print preview load takes priority
        setTimeout(() => {
            setTimeout(() => {
                this.sharedService.pageToPdfTrigger = !this.sharedService.pageToPdfTrigger;
            }, 0);
            this.spinnerService.showSpinner = false;
        }, 500);

    }
}
